type RetryHandler = (fileId: string) => void;
const handlers = new Map<string, RetryHandler>();

export function registerRetryHandler(sessionId: string, handler: RetryHandler): void {
    handlers.set(sessionId, handler);
}

export function unregisterRetryHandler(sessionId: string): void {
    handlers.delete(sessionId);
}

export function callRetryHandler(sessionId: string, fileId: string): void {
    handlers.get(sessionId)?.(fileId);
}
